import { ConfirmActionManager } from './index';

export const SET_MESSAGE_CONFIRM_ACTION_TYPE = 'SET_MESSAGE_CONFIRM_TYPE';

export const setMessage = ({
  message, maxWidth, ok, cancel,
}) => {
  ConfirmActionManager.setCallbacks({ ok, cancel });

  return {
    type: SET_MESSAGE_CONFIRM_ACTION_TYPE,
    payload: { message, maxWidth },
  };
};
